import React from "react";

import SvgIcon from "components/Common/SvgIcon";
import "./style.scss";

const adaURL = "https://www.ada.support/";
const Footer = () => (
  <div className="Footer">

    <div className="Footer__icon-container">
      <SvgIcon
        height={33}
        icon="Ada"
        customClassName="Footer_icon-container__icon"
        link={adaURL}
      />
      <p>Ada Support Inc. &copy; 2020 </p>
    </div>

    <div className="Footer__links-container">
      <a target="_blank" rel="noopener noreferrer" href={`${adaURL}terms`}>Terms</a>
      <a target="_blank" rel="noopener noreferrer" href={`${adaURL}security`}>Security</a>
      <a target="_blank" rel="noopener noreferrer" href={`${adaURL}privacy`}>Privacy</a>
      <a target="_blank" rel="noopener noreferrer" href="https://status.ada.support/">Status</a>
    </div>
  </div>
);


export default Footer;
